import { render, staticRenderFns } from "./CalcStatChip.vue?vue&type=template&id=3bf5020d&scoped=true"
import script from "./CalcStatChip.vue?vue&type=script&lang=js"
export * from "./CalcStatChip.vue?vue&type=script&lang=js"
import style0 from "./CalcStatChip.vue?vue&type=style&index=0&id=3bf5020d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bf5020d",
  null
  
)

export default component.exports